// Mirrors the backend's TechnologyReportMatchMode enum (CVPortal.Logic.Models.Reports).
// Sent/received as the raw numeric value — no global StringEnumConverter is registered
// (Startup.cs's AddNewtonsoftJson), so enums serialize as integers by default.
export const TechnologyReportMatchMode = {
    Any: 1,
    All: 2,
} as const;

export type TechnologyReportMatchModeValue =
    (typeof TechnologyReportMatchMode)[keyof typeof TechnologyReportMatchMode];

export interface TechnologyReportSearchRequest {
    technologyIds: number[];
    matchMode: TechnologyReportMatchModeValue;
    page: number;
    pageSize: number;
}

/** Same filter shape as the search request, minus paging — backs "Export CV for all matching." */
export interface TechnologyReportAllIdsRequest {
    technologyIds: number[];
    matchMode: TechnologyReportMatchModeValue;
}

export interface TechnologyReportPersonRow {
    personId: number;
    firstName: string;
    lastName: string;
    email: string;
    officeLocation: string | null;
    thumbnailBase64: string | null;
    matchedTechnologyNames: string[];
}

export interface TechnologyReportPagedResult {
    items: TechnologyReportPersonRow[];
    totalCount: number;
    page: number;
    pageSize: number;
    totalPages: number;
}

/** Shape returned by GET /api/technology-graph/canonicals/{id}/expand */
export interface CanonicalExpansionResult {
    startCanonicalId: number | null;
    resolved: boolean;
    matchedCanonicals: { id: number; name: string; relevanceScore: number }[];
    /** Raw Technologies.Id values for SQL joining against PersonTechnologies. */
    technologyIds: number[];
}

/** Shape returned by GET /api/position-profiles/{id}/resolve-technologies */
export interface ResolvedProfileTechnologies {
    profileId: number;
    technologyIds: number[];
}
